
(function(){
  // Mobile menu toggle
  function qs(s){return document.querySelector(s);}
  var btn = qs('[data-pb-mobile-toggle]');
  var menu = qs('[data-pb-mobile-menu]');
  if(btn && menu){
    btn.addEventListener('click', function(){
      var open = menu.style.display === 'block';
      menu.style.display = open ? 'none' : 'block';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  // Smooth scroll for in-page anchors
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var id = a.getAttribute('href').slice(1);
    var el = document.getElementById(id);
    if(!el) return;
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth', block:'start'});
    history.replaceState(null,'','#'+id);
  });
})();
